import { relationData } from '../features/relationList';

export default (ids: string[]) =>
  relationData.filter(item => ids.includes(item.name));
